export function handleFilterParams(filters: Record<string, any>, params: URLSearchParams) {
    Object.entries(filters).forEach(([k, v]) => {
        if (!v || (Array.isArray(v) && v.length === 0)) return;
        if (k === 'sourceName' && Array.isArray(v)) {
            // v is an array of account objects with sourceId
            const ids = v.map((acc) => acc.sourceId).filter(Boolean);
            if (ids.length > 0) {
                params.append('sourceIds', ids.join(','));
            }
        } else {
            params.append(k, v);
        }
    });
}
